import { connect } from 'react-redux';

import { GET_MY_PLACE } from 'store/place/actionTypes';
import {
  GET_EXTRANET_NOTIFICATION,
  READ_EXTRANET_NOTIFICATION,
  READ_EXTRANET_NOTIFICATION_SUCCESS,
} from 'store/extranet-notification/actionTypes';

import HeaderExtranet from './HeaderExtranet';

const mapStateToProps = (state) => ({
  myPermission: state.Administrator.myPermission,
  isLoadingGetMyPlace: state.Place.isLoadingGetMyPlace,
  myPlace: state.Place.myPlace,
  extranetNotification: state.ExtranetNotification.extranetNotification,
  isLoadingGetExtranetNotification: state.ExtranetNotification.isLoadingGetExtranetNotification,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetMyPlace: (payload) => dispatch({
    type: GET_MY_PLACE,
    payload,
  }),
  actionGetExtranetNotification: (payload) => dispatch({
    type: GET_EXTRANET_NOTIFICATION,
    payload,
  }),
  actionReadExtranetNotification: (payload) => dispatch({
    type: READ_EXTRANET_NOTIFICATION,
    payload,
  }),
  actionSyncExtranetNotification: (payload) => dispatch({
    type: READ_EXTRANET_NOTIFICATION_SUCCESS,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderExtranet);
